import { Fragment, useContext, useReducer, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";

import { Dialog, Transition } from "@headlessui/react";

import { ToastContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import sendData from "common/fetch/post";
import trigger from "common/trigger";

import ButtonNew from "components/atoms/ButtonNew/index";
import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import { FaTimes } from "components/atoms/Icon/fa/FaTimes";
import Image from "components/atoms/Img";

/** ========== */

const Component = (props) => {
  /* Variables Define */
  const { show, onHide, ebookdata } = props;

  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    formState: { isSubmitting, errors },
  } = useForm();

  const dataFormIdReducer = (state, action) => {
    switch (action) {
      // Hong-kong
      case 20: // Checked
        return 17;
      case 17: // Uncheck
        return 20;
      // Delaware
      case 24: // Checked
        return 25;
      case 25: // Uncheck
        return 24;
      // Offshore
      case 21: // Checked
        return 23;
      case 23: // Uncheck
        return 21;
      case 26: // Checked
        return 27;
      case 27: // Uncheck
        return 26;
      case "reset":
        return ebookdata.form_id;
      default:
        throw new Error();
    }
  };

  const [dataFormID, dispatch] = useReducer(
    dataFormIdReducer,
    ebookdata.form_id
  );
  const { openAlert } = useContext(ToastContext);
  const [loading, setLoading] = useState(false);
  const recaptchaRef = useRef();

  /* Handle Event */

  const closeModal = () => {
    reset();
    clearErrors();
    setLoading(false);
    onHide();
  };
  const onSubmit = async (data) => {
    const token = await recaptchaRef.current.executeAsync();

    if (token) {
      const GAUserID = getGAUserID();
      const dataForSend = { ...data };

      dataForSend.client_id = GAUserID ? GAUserID : "";
      dataForSend.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;
      dataForSend.contact_from_id = dataFormID;
      try {
        document.getElementById("popup-content-panel").style.display = "none";
        // Axios
        //   .post(
        //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/profile_request`,
        //     Data,
        //     {
        //       Headers: {
        //         "captcha-response": token,
        //       },
        //     }
        //   )
        sendData({
          api: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/profile_request`,
          dataForSend,
          token,
        })
          .then((res) => {
            if (res.state) {
              reset();
              clearErrors();
              trigger(
                "contact_form",
                data,
                dataFormID && [20, 24, 21, 26].includes(dataFormID)
                  ? `RMD - Ebook - ${ebookdata.country}`
                  : `Ebook - ${ebookdata.country}`
              );
              openAlert(2000, "success");
              setTimeout(() => {
                closeModal();
              }, 2000);
            } else {
              document.getElementById("popup-content-panel").style.display =
                "block";
              openAlert(3000, "error");
              console.log("error");
            }
          })
          .catch((e) => {
            document.getElementById("popup-content-panel").style.display =
              "block";
            openAlert(3000, "error");
            console.log("error", e);
          });
      } catch (e) {
        document.getElementById("popup-content-panel").style.display = "block";
        clearErrors();
        openAlert(3000, "error");
        console.log("error", e);
      }
    }
  };

  return (
    <Transition show={show} as={"div"}>
      <Dialog
        as="div"
        unmount={false}
        className="fixed inset-0 overflow-y-auto"
        style={{ zIndex: 51 }}
        onClose={closeModal}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-slate-900 opacity-70" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              id="popup-content-panel"
              className={
                "relative inline-flex  w-full  transform  flex-col justify-center rounded-2xl border-2 bg-gradient-to-br from-[#81F5FF] to-[#FFD5E5] px-6 py-10 text-center align-middle shadow-xl transition-all"
              }
              style={{
                minHeight: "600px",
                maxWidth: "400px",
              }}
            >
              <div className={"absolute top-6 right-4 z-10"}>
                <button
                  type="button"
                  className="inline-flex justify-center rounded-full border-2 border-white p-1 text-xs  font-medium text-white transition-all  hover:border-bbc-red-300 hover:text-bbc-red-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                  onClick={closeModal}
                >
                  <FaTimes size={12} />
                </button>
              </div>

              <div className=" relative z-10">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  data-id-form={dataFormID}
                >
                  <Fragment>
                    <input
                      {...register("name", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      className={
                        " mt-6  w-full rounded-full border-0 px-4  py-2  text-bbc-gray focus:outline-none"
                      }
                      required
                      disabled={isSubmitting}
                      type="text"
                      placeholder="Your Full Name"
                    />
                    {(errors.first_name?.type === "required" ||
                      errors.first_name?.type === "invalid") && (
                      <span className="block pt-2 pl-2 text-sm text-red-500">
                        {errors.first_name?.message}
                      </span>
                    )}

                    <input
                      type="email"
                      {...register("email", {
                        required: {
                          value: true,
                          message: "Email is required",
                        },
                        pattern: {
                          value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
                          message: "Invalid e-mail",
                        },
                      })}
                      placeholder="Your Email"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                      className=" mt-6  w-full rounded-full border-0 px-4  py-2  text-bbc-gray transition-colors
                                          duration-200 invalid:border-pink-500 invalid:text-pink-600
                                          focus:bg-white focus:outline-none
                                          focus:outline-hidden focus:ring-0
                                          focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
                    />
                    {(errors.email?.type === "required" ||
                      errors.email?.type === "invalid") && (
                      <span className="block pt-2 pl-2 text-sm text-red-500">
                        {errors.email?.message}
                      </span>
                    )}

                    <label className=" my-6 flex px-3 ">
                      <input
                        type="checkbox"
                        // {...register("checkboxEbook")}
                        className="bbc-checkbox mt-1 "
                        onClick={() => {
                          dispatch(dataFormID);
                        }}
                        defaultChecked={true}
                      />
                      <span className="inline-block  text-center  ">
                        I would like to receive more helpful insights into
                        {` ${ebookdata.country}`}
                      </span>
                    </label>
                    <ButtonNew
                      type="submit"
                      othersClass=" min-w-[170px] relative"
                      disabled={loading}
                      onClick={() => {
                        if (isSubmitting) setLoading(true);
                      }}
                    >
                      {isSubmitting && (
                        <BiLoaderAlt
                          className="absolute left-4 top-2.5 animate-spin"
                          size={20}
                        />
                      )}
                      Get It Free
                    </ButtonNew>
                    <p className="my-6">
                      Document will be sent to your email shortly after
                      successful submission.
                    </p>

                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={process.env.NEXT_PUBLIC_G_RECAPTCHA_V3_SITE_KEY}
                      badge="inline"
                      size="invisible"
                      className="flex justify-center"
                    />
                  </Fragment>
                </form>
              </div>
              <div className="absolute bottom-0 left-0 h-full w-full overflow-hidden rounded-2xl">
                <Image
                  src="/assets/images/common/package_popup_bg.png"
                  width={575}
                  height={491}
                  alt="Background popup"
                  wrapper={{
                    className: "absolute w-full h-auto left-0 z-0 ",
                    style: { bottom: "-80px" },
                  }}
                />
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Component;

Component.propTypes = {};

Component.defaultProps = {};

/** ========== */
